<template>
  <side-bar class="left-main-side-bar" ref="sidebar" :sections="sections" no-exit-button="true" @open="setSideOpen"
    @close="setSideClosed" :key="$t('frontend_groovemail_components_pricepoint_sidebar_home')" :origin="appName">
    <template :slot="$t('frontend_groovemail_components_pricepoint_sidebar_home')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'dashboard' }" @click="sendToVendorDashboard">
            GrooveMail {{ $t('frontend_groovemail_components_pricepoint_sidebar_dashboard') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'dashboard-tinyemail' }" @click="sendToTinyEmailDashboard">
            Proud Partnership with TinyEmail
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_pricepoint_sidebar_leads')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'Leads2' || $route.name === 'LeadDetail'
          }" @click="sendToLeads">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_leads') }}
          </li>
          <li v-if="userCanImportLeads === 1 && canImportLeads"
            class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'ImportedLeadsListing' }" @click="sendToImportedLeadsListing">
            {{ $t('frontend_groovemail_imported_leads_listing_page_title') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Suppressions' }" @click="sendToSuppressions">
            {{ $t('frontend_groovemail_components_sidebar_suppressions') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_pricepoint_tags_segments')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Lists' }" @click="sendToLists">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_lists') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Tags' }" @click="sendToTags">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_tags') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Category' }" @click="sendToCategory">
            {{ $t('frontend_sites_template_categories') }}
          </li>
          <li class="mb-2 block-data"><router-link to="/segments/new">Segment Builder</router-link></li>
        </ul>
      </div>
    </template>
    <template :slot="$t(
      'frontend_groovemail_components_pricepoint_sidebar_campaigns_header'
    )
      ">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Broadcasts' }" @click="sendToBroadcasts">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_broadcasts') }}
          </li>
          <li class="mb-2 block-data"><router-link to="/sequences/new">Groove Sequence Builder</router-link></li>
          <li class="mb-2 block-data"><router-link to="/templates/new">Email templates</router-link></li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'EmailTemplateCategories' || $route.name === 'BroadcastCategories'
          }" @click="sendToEmailTemplateCategories">
            {{ $t('frontend_sidebar_menu_categories') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_pricepoint_sidebar_automations')
      ">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data"><router-link to="/automations/new">Groove Automations</router-link></li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_sidebar_forms')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data"><router-link to="/forms/new">New Groove forms</router-link></li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Forms' }" @click="sendToForms">
            Groove forms legacy
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'CustomField' }" @click="sendToFields">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_customfields') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_sender_title')">
      <div>
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'Settings' &&
              $route.query.type === 'sender' ||
              $route.name === 'EditSender' ||
              $route.name === 'NewSender'
          }" @click="sendToEmailSender">
            {{ $t('frontend_groovemail_settings_sender_settings') }}
          </li>
          <li class="mb-2 block-data"><a href="https://mailbaser.com/integrations?source=groovemail" target="_blank" rel="noopener noreferrer">Universal Integrations ↗</a></li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'Settings' &&
              $route.query.type === 'integeration' ||
              $route.name === 'CreateIntegeration' ||
              $route.name === 'EditIntegeration'
          }" @click="sendToSmsSender">
            {{ $t('frontend_groovemail_settings_integeration_settings') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'Settings' && $route.query.type === 'recipients'
          }" @click="sendToRecipient">
            {{ $t('frontend_groovemail_settings_recipients_settings') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_sidebar_analytics')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary" :class="{
            'text-primary': $route.name === 'LeadAnalytics' || $route.name === 'analyticsLeadDetail'
          }" @click="sendToLeadAnalytics">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_leads') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'ListAnalytics' }" @click="sendToListAnalytics">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_lists') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'BroadcastAnalytics' }" @click="sendToBroadcastAnalytics">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_broadcasts') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'SequenceAnalytics' }" @click="sendToSequenceAnalytics">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_sequences') }}
          </li>
        </ul>
      </div>
    </template>
    <template :slot="$t('frontend_groovemail_components_sidebar_admin')">
      <div class="text-sm">
        <ul class="cursor-pointer text-white list-reset p-4 blocks-container gm-sidebar-admin">
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'AdminSetting' }" @click="sendToadminSetting">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_settings') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'AdminCampaign' }" @click="sendToadminCampaign">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_campaigns') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'AdminForm' }" @click="sendToadminForm">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_forms') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'AdminSequence' }" @click="sendToadminSequence">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_sequence_emails') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'AdminSmtp' }" @click="sendToadminSMTP">
            {{ $t('frontend_groovemail_components_pricepoint_sidebar_smtpsettings') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'TrackingDomains' }" @click="sendToTrackingDomains">
            {{ $t('frontend_groovemail_tracking_domains_route_page_title') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'Blocklists' }" @click="sendToBlocklists">
            {{ $t('frontend_groovemail_admin_blocklists') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'SafeList' }" @click="sendToSafelists">
            {{ $t('frontend_groovemail_sidebar_submenu_safelist') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'UserSenders' }" @click="sendTouserSenders">
            {{ $t('frontend_groovemail_admin_user_sender_title') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'UserIpBlock' }" @click="sendTouserIpBlocks">
            {{ $t('frontend_groovemail_ip_block_title') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'VerificationContent' }" @click="sendToVerificationContent">
            {{ $t('frontend_groovemail_admin_verification_email_content') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'GrooveUsers' }" @click="sendToUsers">
            {{ $t('frontend_groovemail_admin_groove_users') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'ImportUserApprovals' }" @click="sendToImportUserApprovals">
            {{ $t('frontend_groovemail_admin_import_user_approvals') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'SpamAlerts' }" @click="sendToSpamAlerts">
            {{ $t('frontend_groovemail_admin_alerts') }}
          </li>
          <li class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'BounceMessageSettings' }" @click="sendToBounceMessageSettings">
            {{ $t('frontend_groovemail_admin_bounce_message_settings_route_page_title') }}
          </li>
          <!-- removing quill email builder -->
          <!-- <li
            class="mb-2 block-data relative focus:outline-none hover:text-primary"
            :class="{ 'text-primary': $route.name === 'GlobalTemplates' }"
            @click="sendToGlobalTemplates"
          >
            {{ $t('frontend_groovemail_admin_global_templates_page_header') }}
          </li> -->
          <!-- removing quill email builder -->
        </ul>
      </div>
    </template>
    <template slot="header">
      <div class="flex flex-col">
        <div>{{ appName }}</div>
      </div>
    </template>
  </side-bar>
</template>

<script>
import auth from '@groovepages/gd-lib/auth';
import SideBar from '../design-system/sidebar-adapter';
import { mapGetters, mapState } from 'vuex';
import api from '@groovepages/gd-lib/api';

// Import icons
import HomeIcon from '@/assets/images/icons/new/home_new.svg';
import LeadsIcon from '@/assets/images/icons/new/leads_new.svg';
import ListIcon from '@/assets/images/icons/new/list_menu_new.svg';
import CampaignsIcon from '@/assets/images/icons/new/email_new.svg';
import AutomateIcon from '@/assets/images/icons/new/automations_new.svg';
import FormsIcon from '@/assets/images/icons/new/forms_new.svg';
import SendersIcon from '@/assets/images/icons/new/senders_new.svg';
import AnalyticsIcon from '@/assets/images/icons/new/analytics_new.svg';
import AdminIcon from '@/assets/images/icons/new/admin_new.svg';


export default {
  name: 'SidebarMenu',

  data() {
    return {
      appName: '',
    };
  },
  components: {
    SideBar,
  },

  computed: {
    // Used to return lists value from store.
    ...mapState(['filters']),

    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.supBrand.title;
    },

    userCanImportLeads() {
      return this.getCanImportLeads();
    },

    // new plans based limit check
    canImportLeads() {
      return auth.fetchFeatureValue('groovemail_can_import_contacts') === 1;
    },

    defaultEmailApp() {
      return this.$store.state.user.metadata.default_email_app;
    },

    sections() {
      const sections = [
        {
          name: this.$t('frontend_groovemail_components_pricepoint_sidebar_home'),
          icon: HomeIcon,
        },
        {
          name: this.$t('frontend_groovemail_components_pricepoint_sidebar_leads'),
          icon: LeadsIcon,
        },
        {
          name: this.$t('frontend_groovemail_components_pricepoint_tags_segments'),
          icon: ListIcon,
        },
        {
          name: this.$t('frontend_groovemail_components_pricepoint_sidebar_campaigns_header'),
          icon: CampaignsIcon,
        },
        {
          name: this.$t('frontend_groovemail_components_pricepoint_sidebar_automations'),
          icon: AutomateIcon,
          doNotOpen: 1,
        },
        {
          name: this.$t('frontend_groovemail_components_sidebar_forms'),
          icon: FormsIcon,
        },
        {
          name: this.$t('frontend_groovemail_sender_title'),
          icon: SendersIcon,
        },
        {
          name: this.$t('frontend_groovemail_components_sidebar_analytics'),
          icon: AnalyticsIcon,
        },
      ];

      if (this.$store.state.user.admin) {
        sections.push({
          name: this.$t('frontend_groovemail_components_sidebar_admin'),
          icon: AdminIcon,
        });
      }

      if (this.defaultEmailApp == 'groovemail') {
        return sections;
      }

      return [
        {
          name: this.$t('frontend_groovemail_components_pricepoint_sidebar_home'),
          icon: HomeIcon,
        },
      ];
    },
  },

  async mounted() {
    const innerSideBarContent = document.getElementById('left_sidebar');
    innerSideBarContent.id = 'left_sidebar_mail';

    this.appName = this.supBrandName;
  },

  methods: {
    ...mapGetters('mailing', ['getCanImportLeads']),

    setSideOpen(side) {
      const activeSideBarElement =
        document.getElementsByClassName('activeSideBar');
      if (activeSideBarElement && activeSideBarElement[0]) {
        activeSideBarElement[0].classList.add('activeSideBarMail');
        activeSideBarElement[0].classList.remove('activeSideBar');
      }

      if (side === this.$t('frontend_groovemail_components_pricepoint_sidebar_home')) {
        //this.sendToVendorDashboard();
      } else if (side === this.$t('frontend_groovemail_components_pricepoint_sidebar_automations')) {
        this.sendToAutomations();
      } else if (side === this.$t('frontend_groovemail_components_sidebar_admin') && !this.$route.fullPath.includes('/admin')) {
        this.sendToadminSetting();
      }
      this.currentOpenMenuItem = side;
    },

    setSideClosed() {
      this.currentOpenMenuItem = '';
    },

    // close the Phone sidebar
    closeLeftSidebar() {
      this.$refs.sidebar.closeLeftSidebar();
    },

    sendToVendorDashboard() {
      this.closeLeftSidebar();
      this.updateMeta('groovemail');
      this.$router.push({ name: 'dashboard' }).catch(() => { });
    },

    sendToTinyEmailDashboard() {
      this.closeLeftSidebar();
      this.updateMeta('tinyemail');
      this.$router.push({ name: 'dashboard-tinyemail' }).catch(() => { });
    },

    updateMeta(default_email_app) {
      auth.updateMeta({
        default_email_app: default_email_app
      });
      api.post(
        `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/users/update-meta/${auth.authenticatedUser().id}`, {
        default_email_app: default_email_app
      }
      ).catch(() => { });
    },

    sendToAffiliatesDashboard() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'affiliates_dashboard' }).catch(() => { });
    },

    sendToForms() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Forms' }).catch(() => { });
    },

    sendToLists() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Lists' }).catch(() => { });
    },

    sendToLeads() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Leads2' }).catch(() => { });

      // clear the query filters
      this.$store.dispatch('clearFilterQuery');
    },

    sendToTags() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Tags' }).catch(() => { });
    },

    sendToCategory() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Category' }).catch(() => { });
    },

    sendToSegments() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Segments' }).catch(() => { });
    },

    sendToFields() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'CustomField' }).catch(() => { });
    },

    sendToBroadcasts() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Broadcasts' }).catch(() => { });
    },

    sendToTemplates(tabQuery) {
      this.closeLeftSidebar();
      this.$router.push({ name: 'MyTemplates', query: { type: tabQuery } }).catch(() => { });
    },

    sendToSequences() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Sequences' }).catch(() => { });
    },

    sendToAutomations() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'Automations' }).catch(() => { });
    },

    sendToListAnalytics() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'ListAnalytics' }).catch(() => { });
    },

    sendToLeadAnalytics() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'LeadAnalytics' }).catch(() => { });
    },

    async sendToBroadcastAnalytics() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'BroadcastAnalytics' }).catch(() => { });
    },

    async sendToSequenceAnalytics() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'SequenceAnalytics' }).catch(() => { });
    },

    sendToadminSetting() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'AdminSetting' }).catch(() => { });
    },

    sendToadminCampaign() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'AdminCampaign' }).catch(() => { });
    },

    sendToadminForm() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'AdminForm' }).catch(() => { });
    },

    sendToEmailSender() {
      this.$router
        .push({ name: 'Settings', query: { type: 'sender' } })
        .catch(() => { });
    },

    sendToSmsSender() {
      this.$router
        .push({ name: 'Settings', query: { type: 'integeration' } })
        .catch(() => { });
    },

    sendToRecipient() {
      this.$router
        .push({ name: 'Settings', query: { type: 'recipients' } })
        .catch(() => { });
    },

    sendToadminSMTP() {
      this.closeLeftSidebar();
      this.$router.push({ name: 'AdminSmtp' }).catch(() => { });
    },

    sendToadminSequence() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'AdminSequence' }).catch(() => { });
    },

    sendToBlocklists() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'Blocklists' }).catch(() => { });
    },

    sendTouserSenders() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'UserSenders' }).catch(() => { });
    },

    sendTouserIpBlocks() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'UserIpBlock' }).catch(() => { });
    },

    sendToVerificationContent() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'VerificationContent' }).catch(() => { });
    },

    sendToUsers() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'GrooveUsers' }).catch(() => { });
    },

    sendToSafelists() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'SafeList' }).catch(() => { });
    },

    sendToTrackingDomains() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'TrackingDomains' }).catch(() => { });
    },

    sendToSuppressions() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'Suppressions', query: { type: 'unsubscribes' }, }).catch(() => { });
    },

    sendToImportUserApprovals() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'ImportUserApprovals' }).catch(() => { });
    },

    sendToImportedLeadsListing() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'ImportedLeadsListing' }).catch(() => { });
    },

    sendToEmailTemplateCategories() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'EmailTemplateCategories' }).catch(() => { });
    },
    sendToSpamAlerts() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'SpamAlerts' }).catch(() => { });
    },
    sendToBounceMessageSettings() {
      this.closeLeftSidebar();
      this.$emit('closeLeftSidebar');
      this.$router.push({ name: 'BounceMessageSettings' }).catch(() => { });
    },
    // removing quill email builder
    // sendToGlobalTemplates() {
    //   this.closeLeftSidebar();
    //   this.$router.push({ name: 'GlobalTemplates' }).catch(() => {});
    // },
    // removing quill email builder
  },
};
</script>
<style lang="scss">
.left-main-side-bar {

  .cursor-pointer.flex-shrink-0.inline-flex.items-center.justify-center,
  .activeSideBarMail {
    height: 2rem;
  }

  nav>div {
    align-items: center;
  }

  /* Admin section: design-system rest / hover / active states. The panel is
     dark, so "muted → foreground" is expressed as primary-foreground at
     reduced → full opacity; the current route is --gs-primary at 600. */
  .gm-sidebar-admin .block-data {
    color: var(--gs-primary-foreground, #ffffff);
    opacity: 0.78;
    font-weight: 500;
    transition: color 150ms ease, opacity 150ms ease;
  }

  .gm-sidebar-admin .block-data:hover {
    color: var(--gs-primary-foreground, #ffffff);
    opacity: 1;
  }

  .gm-sidebar-admin .block-data.text-primary,
  .gm-sidebar-admin .block-data.text-primary:hover {
    color: var(--gs-primary, #f22987);
    opacity: 1;
    font-weight: 600;
  }
}
</style>
